import React, {useState} from 'react';

export const IntroducirCodigoConfirmacion = (props) => {
	const {codigoConfirmacion, setCodigoConfirmacion, estadoRecuperarContraseña, comprobarCodigo} =
		props;

	return (
		<div className='ContentOlvContraseña'>
			<div className='centrador'>Introduzca el código que le llegó al correo</div>
			<div className='inputCorreoOlvidarContraseña'>
				{estadoRecuperarContraseña === 4 && (
					<div className='centrador correroInvalido'>
						El código introducido es erróneo
					</div>
				)}
				<input
					type='text'
					placeholder='Codigo de confirmacion'
					className='usernameFormularioLoginStandar inputFormularioLoginStandar inputTextUsuario'
					value={codigoConfirmacion}
					onChange={(e) => setCodigoConfirmacion(e.target.value)}
				/>
			</div>
			<div className='centrador'>
				<div
					className='button'
					onClick={comprobarCodigo}
				>
					<b>Introducir código</b>
				</div>
			</div>
			<div className='centrador'>
				<div className='barraSeparadorContentBodyLoginInterno' />
			</div>
			<div className='centrador linkRestablecerContraseña'>
				<b> reenviar código</b>
			</div>
		</div>
	);
};
